import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { Table, TableRow, TableCol } from '../../../../../components/pdf/Table'
import { TableColLabelValue, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import Image from '../../../../../components/pdf/Image'

const SignatureSection = () => {
  return (
    <View id="7" pageBreakAfter>
      <Text bold size="small">
        7 ASSINATURA
      </Text>

      <Table width="75%" center>
        <TableRow>
          <TableHeadText colSpan={2} align="center">
            Responsável Revisão Técnica do Documento:
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableCol style={{ width: '50%' }}>
            <Text size="small">Engenheiro de Segurança do Trabalho</Text>
            <Text size="small">Rodrigo Ragazini</Text>
            <Text size="small">CREA: 5070254889</Text>
          </TableCol>
          <TableCol>
            <Text size="small">
              Este documento foi assinado com certificado digital (última página), emitido pela ICP-Brasil, através de
              chaves criptográficas.
            </Text>
          </TableCol>
        </TableRow>
      </Table>
      <Separator weight={4} />
      <Table width="75%" center>
        <TableRow>
          <TableCol style={{ width: '50%' }}>
            <Text size="small" bold>
              Elaboração do Programa:
            </Text>
            <Text size="small">Nome/nº do conselho/registro/ Assinatura Digital</Text>
          </TableCol>
          <TableCol>
            <Text size="small" bold>
              Responsável pela Implementação do Programa:
            </Text>
            <Text size="small">Nathalia Correia Naolisk/ CREA: 5063245374-SP</Text>
          </TableCol>
        </TableRow>

        <TableRow>
          <TableCol></TableCol>
          <TableCol>
            <Image
              src="/pdfs/bioqualynet/signature_nathalia.jpg"
              maxWidth={145}
              style={{ margin: 'auto' }}
              ignoreFixedSize
            />
          </TableCol>
        </TableRow>
      </Table>
      <Separator weight={8} />
    </View>
  )
}

export default SignatureSection
